import { useIntl } from 'react-intl';
import { IconArrowNarrowRight, IconFolder } from '@rossum/ui/icons/tabler';
import {
  ActivityRowLayout,
  PreviousValue,
  RowIcon,
  RowLabel,
  RowValue,
} from '../../core';

type QueueChangeRowProps = {
  previousQueueId: number | null;
  queueId: number | null;
  previousQueueName: string | null;
  queueName: string | null;
};

// Names come from the entry's meta.queue_names lookup; fall back to #<id> when the
// lookup misses (e.g. queue deleted before BE started storing names).
const displayName = (name: string | null, id: number | null) =>
  name ?? (id === null ? null : `#${id}`);

export const QueueChangeRow = ({
  previousQueueId,
  queueId,
  previousQueueName,
  queueName,
}: QueueChangeRowProps) => {
  const intl = useIntl();

  return (
    <ActivityRowLayout
      dataCy="document-history-queue-row"
      label={
        <RowLabel
          label={intl.formatMessage({
            id: 'features.documentHistory.field.queue',
          })}
        />
      }
      labelIcon={<RowIcon icon={IconFolder} />}
      icon={<RowIcon icon={IconArrowNarrowRight} />}
      value={<RowValue value={displayName(queueName, queueId)} />}
      secondary={
        <PreviousValue>
          <RowValue
            value={displayName(previousQueueName, previousQueueId)}
            secondary
          />
        </PreviousValue>
      }
    />
  );
};
